import { defineMessages } from 'react-intl'

export const channelMessages = defineMessages({
  accessTokenCreateHelp: {
    defaultMessage: 'Meta Graph long-lived token. Stored securely and never shown again.',
    description: 'channel access token field help',
  },
  accessTokenLabel: {
    defaultMessage: 'Access token',
    description: 'channel field label',
  },
  accessTokenRotateHelp: {
    defaultMessage: 'Leave blank to keep the current token. Enter a new token to rotate it.',
    description: 'channel access token rotate help',
  },
  addChannel: {
    defaultMessage: 'Add channel',
    description: 'channel create dialog header',
  },
  autoReplyBotHelp: {
    defaultMessage:
      'Leave this OFF unless you know the playbook never greets. The bot reads our outbound messages back as its own turns, so an automatic notice on a bot-handled thread can swallow the bot’s next greeting.',
    description: 'channel auto-reply bot-owned toggle help',
  },
  autoReplyBotLabel: {
    defaultMessage: 'Also reply when the bot is handling the chat',
    description: 'channel auto-reply bot-owned toggle label',
  },
  autoReplyEnabledHelp: {
    defaultMessage:
      'Off until you switch it on: a saved-but-disabled configuration sends nothing. Once on, a customer who writes outside the hours below gets one notice, not one per message.',
    description: 'channel auto-reply enable toggle help',
  },
  autoReplyEnabledLabel: {
    defaultMessage: 'Answer automatically outside office hours',
    description: 'channel auto-reply enable toggle label',
  },
  autoReplyHolidaysHelp: {
    defaultMessage:
      'Public holidays then count as closed on top of the weekly hours, using the CRM holiday calendar.',
    description: 'channel auto-reply holidays toggle help',
  },
  autoReplyHolidaysLabel: {
    defaultMessage: 'Observe public holidays',
    description: 'channel auto-reply holidays toggle label',
  },
  autoReplyNoWindowWarning: {
    defaultMessage:
      'The saved office hours could not be read, so this number answers nobody. Set the hours again and save to re-arm it.',
    description: 'channel auto-reply unparsable stored window warning',
  },
  autoReplyPreviewLabel: {
    defaultMessage: 'Customer sees',
    description: 'channel auto-reply message preview label',
  },
  autoReplyTextExample: {
    defaultMessage:
      'Example: “Terima kasih sudah menghubungi kami. Saat ini kami sedang di luar jam kerja — kami akan membalas {placeholder}.”',
    description: 'channel auto-reply message example',
  },
  autoReplyTextHelp: {
    defaultMessage:
      'Write it in Indonesian — the customer reads this, not an operator. Put {placeholder} where the next opening should appear and it is replaced when the message is sent, rendered in the zone above (“Senin pukul 08.00 WIB”). Copy without it is sent word for word.',
    description: 'channel auto-reply message field help',
  },
  autoReplyTextLabel: {
    defaultMessage: 'Reply message',
    description: 'channel auto-reply message field label',
  },
  autoReplyTitle: {
    defaultMessage: 'Out-of-hours auto-reply',
    description: 'channel detail card title',
  },
  autoReplyUpdatedAt: {
    defaultMessage: 'Last saved {date}',
    description: 'channel auto-reply last-saved stamp',
  },
  autoReplyWindowHelp: {
    defaultMessage:
      'When this number IS staffed. The auto-reply fires OUTSIDE these hours, so list the hours you are open — never the hours you are closed.',
    description: 'channel auto-reply office-hours section help',
  },
  autoReplyWindowTitle: {
    defaultMessage: 'Office hours',
    description: 'channel auto-reply office-hours section title',
  },
  caseActionDefaultsBuiltIn: {
    defaultMessage: 'Built-in default',
    description: 'channel case-action defaults empty option',
  },
  caseActionDefaultsCustomerRepliedHelp: {
    defaultMessage:
      'Action logged on the case the first time the customer answers on this number — this is what counts the case as contacted.',
    description: 'channel case-action defaults customer-replied field help',
  },
  caseActionDefaultsCustomerRepliedLabel: {
    defaultMessage: 'Customer replies',
    description: 'channel field label',
  },
  caseActionDefaultsDeactivated: {
    defaultMessage: '{name} (deactivated)',
    description: 'channel case-action defaults retired type option',
  },
  caseActionDefaultsHelp: {
    defaultMessage:
      'The CRM logs both of these actions by itself, whatever is chosen here — the setting only picks the TYPE they are filed under. A campaign can override either one; Built-in default files the action under the type that ships with the CRM. It never switches the action off.',
    description: 'channel case-action defaults help',
  },
  caseActionDefaultsNoAccess: {
    defaultMessage:
      'Both actions are logged automatically on this number. Choosing which type they are filed under needs the settings permission as well, so they cannot be changed from here.',
    description: 'channel case-action defaults unavailable without MANAGE_SETTINGS',
  },
  caseActionDefaultsScreeningCompletedHelp: {
    defaultMessage:
      'Action logged when a screening playbook on this number hands the case to an operator.',
    description: 'channel case-action defaults screening-completed field help',
  },
  caseActionDefaultsScreeningCompletedLabel: {
    defaultMessage: 'Screening hands over',
    description: 'channel field label',
  },
  caseActionDefaultsTitle: {
    defaultMessage: 'Automatic contact actions',
    description: 'channel detail card title',
  },
  caseTypeBindingHelp: {
    defaultMessage:
      'Cases of other types can then never be worked on this number: campaigns cannot send openers from it, it is refused when starting a conversation, and it disappears from the manual-link picker. Leave it as Any case type unless this number is dedicated to one line of business.',
    description: 'channel case-type binding help',
  },
  caseTypeBindingTitle: {
    defaultMessage: 'Case type',
    description: 'channel detail card title',
  },
  caseTypeLabel: {
    defaultMessage: 'Serves case type',
    description: 'channel field label',
  },
  caseTypeUnbound: {
    defaultMessage: 'Any case type',
    description: 'channel case-type binding empty option',
  },
  channelInfoTitle: {
    defaultMessage: 'Number',
    description: 'channel detail card title',
  },
  conversationOwnershipTitle: {
    defaultMessage: 'Conversation ownership',
    description: 'channel detail card title',
  },
  createSuccess: {
    defaultMessage: 'Channel provisioned',
    description: 'channel create success notification',
  },
  credentialsTitle: {
    defaultMessage: 'Credentials',
    description: 'channel detail card title',
  },
  defaultOversightHelp: {
    defaultMessage:
      'Operator-QA oversight profile applied to conversations opened on this channel that are not already governed by a campaign or case type. None means oversight is off by default.',
    description: 'channel default oversight field help',
  },
  defaultOversightLabel: {
    defaultMessage: 'Default oversight scenario',
    description: 'channel field label',
  },
  defaultOversightNone: {
    defaultMessage: 'None (oversight off)',
    description: 'channel default oversight none option',
  },
  defaultOwnerBot: {
    defaultMessage: 'Bot',
    description: 'channel default owner option',
  },
  defaultOwnerHelp: {
    defaultMessage:
      'Who handles a new conversation on this channel before any campaign takes over. Bot hands it to the default playbook; Human waits for an operator.',
    description: 'channel default owner field help',
  },
  defaultOwnerHuman: {
    defaultMessage: 'Human',
    description: 'channel default owner option',
  },
  defaultOwnerLabel: {
    defaultMessage: 'Default owner',
    description: 'channel field label',
  },
  defaultPlaybookHelp: {
    defaultMessage:
      'Intake bot for conversations the customer opens first (website/ads click-to-WhatsApp, cold messages). Unknown senders always land here; a recognised customer without an open case does too unless a Support playbook is set. None means those conversations wait for a human in the triage inbox.',
    description: 'channel default playbook field help',
  },
  defaultPlaybookLabel: {
    defaultMessage: 'Default playbook',
    description: 'channel field label',
  },
  defaultPlaybookNone: {
    defaultMessage: 'None (no bot)',
    description: 'channel default playbook none option',
  },
  defaultTransactionalBadge: {
    defaultMessage: 'default',
    description: 'channel list default transactional badge',
  },
  defaultTransactionalHelp: {
    defaultMessage:
      'Automated system messages (portal sign-in codes and invites) are sent from the default transactional number. Turning this on moves the default off any other channel.',
    description: 'channel default transactional toggle help',
  },
  defaultTransactionalLabel: {
    defaultMessage: 'Default transactional channel',
    description: 'channel field label',
  },
  displayNumberHelp: {
    defaultMessage: 'The customer-facing WhatsApp number, e.g. +1 555 010 0123',
    description: 'channel display number field help',
  },
  displayNumberLabel: {
    defaultMessage: 'Display number',
    description: 'channel field label',
  },
  emptyTable: {
    defaultMessage: 'No channels found',
    description: 'channel list empty state',
  },
  healthEmpty: {
    defaultMessage:
      'No health reading for this number yet. One appears after the platform reads it from Meta, or straight away if you run a connection check.',
    description: 'channel number-health empty state',
  },
  healthMirrorNote: {
    defaultMessage:
      'Meta’s own reading, mirrored. Nothing here blocks a send — a poor rating is the cue to check Business Manager, not a limit the CRM applies.',
    description: 'channel number-health inform-only note',
  },
  healthQualityEventLabel: {
    defaultMessage: 'Last quality event',
    description: 'channel number-health field label',
  },
  healthStaleHelp: {
    defaultMessage:
      'This reading is over {hours, plural, one {# hour} other {# hours}} old and may no longer be true. Run Verify connection for a live one.',
    description: 'channel number-health staleness warning',
  },
  healthSyncedLabel: {
    defaultMessage: 'As of',
    description: 'channel number-health read-time label',
  },
  healthSyncedNever: {
    defaultMessage: 'never read',
    description: 'channel number-health read-time when the platform has no timestamp',
  },
  healthTitle: {
    defaultMessage: 'Number health',
    description: 'channel detail card title',
  },
  identityImmutableHelp: {
    defaultMessage:
      'Phone number ID and WhatsApp Business Account ID are set at provisioning and cannot be changed.',
    description: 'channel detail identity immutable help',
  },
  identityTitle: {
    defaultMessage: 'Identity',
    description: 'channel detail card title',
  },
  messagingLimitLabel: {
    defaultMessage: 'Messaging limit',
    description: 'channel field label — Meta messaging limit tier',
  },
  metaAppIdHint: {
    defaultMessage:
      'Needed only to put an image in a template header. It is the app whose ' +
      'system user issued this number\u2019s access token — rotate one and you ' +
      'may need to change the other.',
    description: 'channel form hint',
  },
  metaAppIdLabel: {
    defaultMessage: 'Meta app ID (optional)',
    description: 'channel form field',
  },
  oversightTitle: {
    defaultMessage: 'Oversight',
    description: 'channel detail card title',
  },
  phoneNumberIdLabel: {
    defaultMessage: 'Phone number ID',
    description: 'channel field label',
  },
  playbooksTitle: {
    defaultMessage: 'Playbooks',
    description: 'channel detail card title',
  },
  providerLabel: {
    defaultMessage: 'Provider',
    description: 'channel field label',
  },
  purposeCreateHelp: {
    defaultMessage:
      'Cannot be changed later. Transactional numbers are for automated template sends only (e.g. notifications) — they never appear in operator or campaign surfaces.',
    description: 'channel purpose field help',
  },
  purposeLabel: {
    defaultMessage: 'Purpose',
    description: 'channel field label',
  },
  qualityColumn: {
    defaultMessage: 'Quality',
    description: 'channel list column — Meta quality rating',
  },
  registerNumberButton: {
    defaultMessage: 'Register number',
    description: 'channel verify dialog register action',
  },
  registerNumberPinHelp: {
    defaultMessage:
      "The number's 6-digit two-step verification PIN. If two-step " +
      'verification was never enabled, this call sets it to the PIN you ' +
      'enter — keep it somewhere safe.',
    description: 'channel verify dialog register pin help',
  },
  registerNumberPinLabel: {
    defaultMessage: 'Two-step PIN',
    description: 'channel verify dialog register pin field label',
  },
  registerNumberSuccess: {
    defaultMessage: 'Number registered with the Cloud API',
    description: 'channel register number success notification',
  },
  statusLabel: {
    defaultMessage: 'Status',
    description: 'channel field label',
  },
  subscribeAppButton: {
    defaultMessage: 'Subscribe app',
    description: 'channel verify dialog subscribe action',
  },
  subscribeAppSuccess: {
    defaultMessage: 'App subscribed to the WABA webhooks',
    description: 'channel subscribe app success notification',
  },
  supportPlaybookHelp: {
    defaultMessage:
      'Fallback bot playbook for a recognised customer who messages in with no active case (the support posture), used when their campaign sets no support playbook of its own. None means no channel-level support fallback.',
    description: 'channel support playbook field help',
  },
  supportPlaybookLabel: {
    defaultMessage: 'Support playbook',
    description: 'channel field label',
  },
  supportPlaybookNone: {
    defaultMessage: 'None (no fallback)',
    description: 'channel support playbook none option',
  },
  tabAutomation: {
    defaultMessage: 'Automation',
    description: 'channel detail tab label',
  },
  tabConfiguration: {
    defaultMessage: 'Configuration',
    description: 'channel detail tab label',
  },
  tabTemplates: {
    defaultMessage: 'Templates',
    description: 'channel detail tab label',
  },
  templateActionsColumn: {
    defaultMessage: 'Actions',
    description: 'channel templates column',
  },
  templateAllLanguagesLabel: {
    defaultMessage: 'Delete every language variant of this name',
    description: 'channel template delete all languages toggle',
  },
  templateBodyLabel: {
    defaultMessage: 'Message body',
    description: 'channel template preview label',
  },
  templateBodyRequired: {
    defaultMessage: 'A template needs a message body.',
    description: 'channel template editor validation',
  },
  templateButtonAdd: {
    defaultMessage: 'Add button',
    description: 'channel template editor action',
  },
  templateButtonPhoneLabel: {
    defaultMessage: 'Phone number',
    description: 'channel template editor field',
  },
  templateButtonTextLabel: {
    defaultMessage: 'Button text',
    description: 'channel template editor field',
  },
  templateButtonUrlExampleLabel: {
    defaultMessage: 'Example URL',
    description: 'channel template editor field',
  },
  templateButtonUrlLabel: {
    defaultMessage: 'URL',
    description: 'channel template editor field',
  },
  templateButtonsLabel: {
    defaultMessage: 'Buttons',
    description: 'channel template editor section',
  },
  templateCategoryColumn: {
    defaultMessage: 'Category',
    description: 'channel templates column',
  },
  templateCategoryLabel: {
    defaultMessage: 'Category',
    description: 'channel template editor field',
  },
  templateCreateAction: {
    defaultMessage: 'New template',
    description: 'channel templates toolbar action',
  },
  templateCreateSuccess: {
    defaultMessage: 'Template submitted to Meta for review',
    description: 'channel template create success notification',
  },
  templateCreateTitle: {
    defaultMessage: 'New message template',
    description: 'channel template editor dialog title',
  },
  templateDeleteAction: {
    defaultMessage: 'Delete',
    description: 'channel templates row action',
  },
  templateDeleteConfirm: {
    defaultMessage: 'Delete template',
    description: 'channel template delete dialog confirm',
  },
  templateDeleteSuccess: {
    defaultMessage: 'Template deleted at Meta',
    description: 'channel template delete success notification',
  },
  templateDeleteTitle: {
    defaultMessage: 'Delete this template?',
    description: 'channel template delete dialog title',
  },
  templateDeleteWarning: {
    defaultMessage:
      'This cannot be undone. Meta locks the name for 30 days after an approved template is deleted, and any outreach ladder already using it will start failing to send.',
    description: 'channel template delete dialog warning',
  },
  templateEditAction: {
    defaultMessage: 'Edit',
    description: 'channel templates row action',
  },
  templateEditNote: {
    defaultMessage:
      'Name and language cannot be changed — Meta fixes both when the template is created. Saving re-submits the template for review.',
    description: 'channel template editor note',
  },
  templateEditSuccess: {
    defaultMessage: 'Template sent to Meta for re-review',
    description: 'channel template update success notification',
  },
  templateEditTitle: {
    defaultMessage: 'Edit message template',
    description: 'channel template editor dialog title',
  },
  templateExampleLabel: {
    defaultMessage: 'Example for {variable}',
    description: 'channel template editor field',
  },
  templateExamplesHint: {
    defaultMessage:
      'Meta requires a sample value for every variable, and rejects the template days later if one is missing.',
    description: 'channel template editor hint',
  },
  templateFooterLabel: {
    defaultMessage: 'Footer (optional)',
    description: 'channel template editor field',
  },
  templateHeaderFormatImage: {
    defaultMessage: 'Image',
    description: 'channel template editor header type',
  },
  templateHeaderFormatLabel: {
    defaultMessage: 'Header',
    description: 'channel template editor field',
  },
  templateHeaderFormatNone: {
    defaultMessage: 'None',
    description: 'channel template editor header type',
  },
  templateHeaderFormatText: {
    defaultMessage: 'Text',
    description: 'channel template editor header type',
  },
  templateHeaderImageChoose: {
    defaultMessage: 'Choose image',
    description: 'channel template editor action',
  },
  templateHeaderImageHint: {
    defaultMessage:
      'JPEG or PNG, up to 5 MB. Every message sent with this template shows this image.',
    description: 'channel template editor hint',
  },
  templateHeaderImageReplace: {
    defaultMessage: 'Replace image',
    description: 'channel template editor action',
  },
  templateHeaderImageRequired: {
    defaultMessage: 'An image header needs an image.',
    description: 'channel template editor validation',
  },
  templateHeaderImageUnreadable: {
    defaultMessage: 'That file could not be read. Pick another one.',
    description: 'channel template editor error',
  },
  templateHeaderImageUploading: {
    defaultMessage: 'Uploading…',
    description: 'channel template editor status',
  },
  templateHeaderLabel: {
    defaultMessage: 'Header (optional)',
    description: 'channel template editor field',
  },
  templateLanguageLabel: {
    defaultMessage: 'Language',
    description: 'channel template editor field',
  },
  templateLocaleColumn: {
    defaultMessage: 'Locale',
    description: 'channel templates column',
  },
  templateNameColumn: {
    defaultMessage: 'Template',
    description: 'channel templates column',
  },
  templateNameHint: {
    defaultMessage:
      'Lowercase letters, numbers and underscores. Cannot be changed later, and a deleted approved name stays reserved for 30 days.',
    description: 'channel template editor hint',
  },
  templateNameLabel: {
    defaultMessage: 'Template name',
    description: 'channel template editor field',
  },
  templateProbeAction: {
    defaultMessage: 'Test template write access',
    description: 'channel verify dialog action',
  },
  templateProbeLeftover: {
    defaultMessage:
      'Write access works, but the test template {name} could not be removed — delete it in Meta Business Manager.',
    description: 'channel template probe warning',
  },
  templateProbeOk: {
    defaultMessage: 'This number\u2019s token can create and delete templates.',
    description: 'channel template probe success',
  },
  templateQualityColumn: {
    defaultMessage: 'Quality',
    description: 'channel templates column',
  },
  templateRejectedReasonLabel: {
    defaultMessage: 'Meta rejected this: {reason}',
    description: 'channel template rejection label',
  },
  templateRejectionRecommendationLabel: {
    defaultMessage: 'Meta suggests: {recommendation}',
    description: 'channel template rejection recommendation',
  },
  templateSearchPlaceholder: {
    defaultMessage: 'Search templates',
    description: 'channel templates filter',
  },
  templateStatusFilterAll: {
    defaultMessage: 'All statuses',
    description: 'channel templates filter',
  },
  templateSyncAction: {
    defaultMessage: 'Sync now',
    description: 'channel templates toolbar action',
  },
  templateSyncSuccess: {
    defaultMessage: 'Synced with Meta: {upserted} updated, {removed} removed',
    description: 'channel template sync success notification',
  },
  templateSyncedColumn: {
    defaultMessage: 'Last synced',
    description: 'channel templates column',
  },
  templateVariablesColumn: {
    defaultMessage: 'Variables',
    description: 'channel templates column',
  },
  templatesEmpty: {
    defaultMessage: 'No templates synced yet for this channel.',
    description: 'channel templates empty state',
  },
  templatesFilteredEmpty: {
    defaultMessage: 'No templates match this search.',
    description: 'channel templates filtered empty state',
  },
  templatesMirrorNote: {
    defaultMessage:
      'Every template here is submitted to Meta for review. Name and language are fixed when it is created, editing one sends it back for review, and authentication templates are managed in Meta Business Manager.',
    description: 'channel templates mirror note',
  },
  templatesTitle: {
    defaultMessage: 'Message templates',
    description: 'channel detail card title',
  },
  transactionalAutoReplyClearButton: {
    defaultMessage: 'Turn off the reply',
    description: 'channel transactional auto-reply clear action',
  },
  transactionalAutoReplyClearWarning: {
    defaultMessage:
      'A customer who writes to this number will then get nothing back at all — no reply, and no sign that anyone saw it. You can switch it back on at any time by naming an approved template again.',
    description: 'channel transactional auto-reply — warning shown while a clear is pending',
  },
  transactionalAutoReplyHelp: {
    defaultMessage:
      'People do reply to OTP messages, and nobody reads this number. Name an approved WhatsApp template here and a customer who writes in gets one automatic answer pointing them somewhere staffed — at most one a day per conversation, however many messages they send. Someone who writes again the next day is answered again.',
    description: 'channel transactional auto-reply card help',
  },
  transactionalAutoReplyLanguageHelp: {
    defaultMessage:
      'Meta locale code of that template, e.g. id or en_US — filled in for you when you pick a template. WhatsApp matches the name and the language TOGETHER, so a template approved in id cannot be sent as en_US.',
    description: 'channel transactional auto-reply template language field help',
  },
  transactionalAutoReplyLanguageLabel: {
    defaultMessage: 'Template language',
    description: 'channel transactional auto-reply template language field label',
  },
  transactionalAutoReplyOffNotice: {
    defaultMessage:
      'No template is configured, so this number answers nobody: a customer who writes to it gets no reply at all. Name an approved template below to start answering.',
    description: 'channel transactional auto-reply unconfigured notice',
  },
  transactionalAutoReplyTemplateApproved: {
    defaultMessage: 'WhatsApp still lists this template as approved on this number.',
    description: 'channel transactional auto-reply saved template is live and approved',
  },
  transactionalAutoReplyTemplateHelp: {
    defaultMessage:
      'The WORDING is not written here. It lives in the WhatsApp template Meta approved, and this field only picks which of those approved templates is sent — changing what the customer reads means submitting a new template and waiting for another review. Pick from this number’s approved templates; only approved ones can be sent.',
    description: 'channel transactional auto-reply template name field help',
  },
  transactionalAutoReplyTemplateLabel: {
    defaultMessage: 'Approved template name',
    description: 'channel transactional auto-reply template name field label',
  },
  transactionalAutoReplyTemplateMissing: {
    defaultMessage:
      'WhatsApp no longer lists a template called “{templateName}” in {templateLanguage} on this number, so this reply cannot be delivered — every customer who writes in gets nothing. Pick one of the approved templates and save again, or turn the reply off.',
    description: 'channel transactional auto-reply saved template is gone from Meta',
  },
  transactionalAutoReplyTemplateNoOptions: {
    defaultMessage:
      'No approved templates on this number yet — submit one in Message templates below.',
    description: 'channel transactional auto-reply template picker empty state',
  },
  transactionalAutoReplyTemplateStatusWarning: {
    defaultMessage:
      'WhatsApp now has “{templateName}” as {status}, not approved. Meta pauses and disables templates on its own, and a reply naming one is dropped — every customer who writes in gets nothing until it is approved again or replaced here.',
    description: 'channel transactional auto-reply saved template is no longer approved',
  },
  transactionalAutoReplyTemplateUnchecked: {
    defaultMessage:
      'The approved-template list for this number could not be read just now, so nothing here has been checked against WhatsApp. The saved template may already have been paused or removed.',
    description: 'channel transactional auto-reply template mirror unreadable',
  },
  transactionalAutoReplyTitle: {
    defaultMessage: 'Automatic reply to inbound messages',
    description: 'channel detail card title',
  },
  transactionalAutoReplyUndoClear: {
    defaultMessage: 'Keep the reply',
    description: 'channel transactional auto-reply — undo a pending clear',
  },
  updateSuccess: {
    defaultMessage: 'Channel updated',
    description: 'channel update success notification',
  },
  verifyButton: {
    defaultMessage: 'Verify connection',
    description: 'channel credentials verify action',
  },
  verifyButtonHelp: {
    defaultMessage:
      'Checks the stored access token live against Meta: phone number access, Cloud API registration, WABA access and the webhook app subscription.',
    description: 'channel credentials verify action help',
  },
  verifyCheckAppSubscription: {
    defaultMessage: 'Webhook app subscription',
    description: 'channel verify check label',
  },
  verifyCheckPhoneNumberAccess: {
    defaultMessage: 'Phone number access',
    description: 'channel verify check label',
  },
  verifyCheckRegistration: {
    defaultMessage: 'Cloud API registration',
    description: 'channel verify check label',
  },
  verifyCheckWabaAccess: {
    defaultMessage: 'WABA access',
    description: 'channel verify check label',
  },
  verifyDialogTitle: {
    defaultMessage: 'Connection check',
    description: 'channel verify dialog title',
  },
  verifyMessagingLimitLabel: {
    defaultMessage: 'Messaging limit',
    description: 'channel verify dialog label',
  },
  verifyNumberStatusLabel: {
    defaultMessage: 'Status',
    description: 'channel verify dialog label',
  },
  verifyPhoneNumberTitle: {
    defaultMessage: 'Phone number',
    description: 'channel verify dialog section title',
  },
  verifyPlatformLabel: {
    defaultMessage: 'Platform',
    description: 'channel verify dialog label',
  },
  verifyQualityRatingLabel: {
    defaultMessage: 'Quality rating',
    description: 'channel verify dialog label',
  },
  verifyStatusFailed: {
    defaultMessage: 'Failed',
    description: 'channel verify check status',
  },
  verifyStatusOk: {
    defaultMessage: 'OK',
    description: 'channel verify check status',
  },
  verifyStatusSkipped: {
    defaultMessage: 'Skipped',
    description: 'channel verify check status',
  },
  verifySubscribedAppsEmpty: {
    defaultMessage: 'No app is subscribed to this WABA — webhooks will not be delivered.',
    description: 'channel verify dialog empty subscribed apps',
  },
  verifySubscribedAppsTitle: {
    defaultMessage: 'Subscribed apps',
    description: 'channel verify dialog section title',
  },
  verifyVerifiedNameLabel: {
    defaultMessage: 'Verified name',
    description: 'channel verify dialog label',
  },
  verifyWabaTitle: {
    defaultMessage: 'WhatsApp Business Account',
    description: 'channel verify dialog section title',
  },
  wabaIdLabel: {
    defaultMessage: 'WhatsApp Business Account ID',
    description: 'channel field label',
  },
})
